import get from 'lodash/get';

export const permissionViewPayouts = state => get(state.currentUserRoleInfo, 'permissions.payouts.view');

export const permissionRequestPayouts = state => get(state.currentUserRoleInfo, 'permissions.payouts.request');

export const permissionAccessDomains = state => get(state.currentUserRoleInfo, 'permissions.domains.access') && state.currentUser.max_domains_allowed > 0;